<template>
  <div class="content">
    <div class="main">

        <div class="container text-center">
          <h2>{{ model.title }}</h2>
        </div>

        <div class="container text-left">
          <span class="text">Tonic Note: </span>
          <select v-model="model.tonic">
            <option v-for="value in model.notes">{{value}}</option>
          </select>
          <span>&nbsp;&nbsp;Full Headers&nbsp;</span>
          <input type="checkbox" v-model="model.fullHeaders" />

          <scales-sheet :tonic="model.tonic" :numSteps="model.steps" :fullHeaders="model.fullHeaders">
          </scales-sheet>

          <div v-if="!model.fullHeaders">
            <span class="text">Equal Steps: </span>
            <select v-model="model.steps">
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>7</option>
              <option>12</option>
            </select>
          </div>

        </div>

    </div>
  </div>
</template>

<script>
import ScalesSheet from './components/scalesSheet.vue'
import * as MusicData from '@/data/music_data'

export default {
  name: "Notes",
  components: {
    ScalesSheet
  },
  data() {
    return {
      model: {
        title: "Modern Western Music Scales",
        notes: MusicData.notes,
        tonic: 'C',
        fullHeaders: false,
        steps: 7
      }
    };
  },
  mounted: function () {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1,
.h1 {
  font-family: "kingthings_organicaextra_bold", Impact, "Arial Black",
    sans-serif;
}
</style>
